import {FC} from 'react';
import { useThemeSwitch } from '../../common/helpers/ThemeSwitch';
import { FaSun } from 'react-icons/fa';
import { RiMoonClearFill } from 'react-icons/ri';
import { SiSwagger } from 'react-icons/si';
import { useSelector } from 'react-redux';
import { IAppState } from '../../common/state/store';

type IFooterProps = {
    absolute?: boolean
}

const Footer: FC<IFooterProps> = ({absolute = false}) => {    
    const [theme, toggleTheme] = useThemeSwitch();
    const appState = useSelector(({app} : {app: IAppState}) => app);
    return (
      <>
        <footer
          className={
            (absolute
              ? "absolute"
              : "relative") + "mt-1 w-full bottom-0 bg-gray-200 dark:bg-gray-800 pb-6"
          }
        >
          <div className="container mx-auto px-4">
            <hr className="mb-6 border-b-1 border-gray-300 dark:border-gray-700" />
            <div className="flex flex-wrap items-center md:justify-between justify-center">
              <div className="w-full md:w-4/12 px-4">
                <div className="invisible sm:invisible md:visible lg:invisible xl:visible text-sm text-gray-600 dark:text-teal-400 font-semibold py-1">
                  Copyright © {" "}
                  <a
                    href="https://www.powerministry.info"
                    className="text-gray-600 dark:text-teal-400 hover:text-pink-600 text-sm font-semibold py-1"
                  >
                    Powerministries (v{appState.version})
                  </a>
                </div>
              </div>
              <div className="w-full md:w-8/12 px-4">
                <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                  <li>
                    <a
                      href="https://www.powerministry.info"
                      className="text-gray-600 dark:text-teal-400 hover:text-pink-600 text-sm font-semibold block py-1 px-3"
                    >
                      Website
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.powerministry.info/about-us.html"
                      className="text-gray-600 dark:text-teal-400 hover:text-pink-600 text-sm font-semibold block py-1 px-3"
                    >
                      About Us
                    </a>
                  </li>                  
                  <li>
                    <a
                      href="https://pmin-api.fly.dev/docs"
                      target="_blank"
                      rel="noreferrer"
                      title="API Docs"
                      className="text-gray-600 dark:text-teal-400 hover:text-pink-600 text-xl font-semibold block py-1 px-3"
                    >
                      <SiSwagger />
                    </a>
                  </li>
                  <li>
                    <button id="button"
                      className="text-gray-600 dark:text-teal-400 cursor-pointer hover:text-pink-600 text-xl font-semibold block py-1 px-3"
                      onClick={toggleTheme}
                    >
                      {theme ? <RiMoonClearFill/> : <FaSun/>}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
};

export default Footer;